module.exports = __webpack_public_path__ + "img/highRiskMarker.bced62cb.svg";